<div class="mct-flex mct-row mct-justify-between mct-items-center" style="margin-bottom: 3rem">
  <h3 id="myTasks">{{ 'dashboard.tasks.label' | translate | titlecase }}</h3>
  <button pButton type="button" class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center" type="button" (click)="taskEditDialog.open()">
    <i class="large-icon pi pi-plus"></i>
    <span>{{ 'profiles.tasks.add-a-task' | translate | uppercase }}</span>
  </button>
</div>
<wl-card>
  <div class="atlas-table">
    <p-table [showGridlines]="true"
      [lazy]="true"
      [rows]="10"
      [value]="searchResult?.Result"
      [paginator]="true"
      (onLazyLoad)="lazyLoadTasks($event)"
      [totalRecords]="searchResult?.TotalCount"
      [hidden]="!searchResult?.Result?.length"
      styleClass="wl-responsive-prime-datatable-borderless"
    >
      <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
        <SortAltIcon *ngIf="sortOrder === 0">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
        </SortAltIcon>
        <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
        </SortAmountUpAltIcon>
        <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
          <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
        </SortAmountDownIcon>
      </ng-template>
      <ng-template pTemplate="header">
        <tr class="wl-prime-datatable-hidden-phone">
          <th pSortableColumn="Descr" style="width: 26%">
            {{ 'dashboard.tasks.description' | translate | titlecase }}
            <p-sortIcon field="Descr"></p-sortIcon>
          </th>
          <th pSortableColumn="DateDue" style="width: 22%">
            {{ 'dashboard.tasks.due-date' | translate | titlecase }}
            <p-sortIcon field="DateDue"></p-sortIcon>
          </th>
          <th pSortableColumn="ProfileReportName" style="width: 20%">
            {{ 'dashboard.tasks.profile' | translate | titlecase }}
            <p-sortIcon field="ProfileReportName"></p-sortIcon>
          </th>
          <th pSortableColumn="AssignedByUserName" style="width: 25%">
            {{ 'dashboard.tasks.assigned-by' | translate | titlecase }}
            <p-sortIcon field="AssignedByUserName"></p-sortIcon>
          </th>
          <th style="width: 9%"></th>
        </tr>
        <tr class="wl-prime-datatable-hidden-tablet-and-bigger">
          <th pSortableColumn="DateDue" style="width: 110px">
            <p-sortIcon field="DateDue"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-task>
        <tr class="tasks-grid-body wl-prime-datatable-hidden-phone">
          <td>
            {{ task.Descr }}
          </td>
          <td [ngClass]="{ 'past-due': task.Late }">{{ task.DateDue | date }}</td>
          <td>
            <a [routerLink]="'/profile/' + task.ProfileID">{{ task.ProfileReportName }} ({{ task.ProfileID }})</a>
          </td>
          <td>{{ task.AssignedByUserName }}</td>
          <td class="atlas-tasks-dashboard-actions" style="padding: 0; text-align: center">
            <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForTask(task)"> </action-button>
          </td>
        </tr>
        <tr class="tasks-grid-body wl-prime-datatable-hidden-tablet-and-bigger">
          <td>
            <div class="mct-grid mct-cols-1-2">
              <div class="f-wb t-al">{{ 'dashboard.tasks.description' | translate | titlecase }}</div>
              <div class="t-al">{{ task.Descr }}</div>
              <div class="f-wb t-al">{{ 'dashboard.tasks.due-date' | translate | titlecase }}</div>
              <div [ngClass]="task.Late ? 'past-due t-al' : 't-al'">{{ task.DateDue | date }}</div>
              <div class="f-wb t-al">{{ 'dashboard.tasks.profile' | translate | titlecase }}</div>
              <div class="t-al">
                <a [routerLink]="'/profile/' + task.ProfileID">{{ task.ProfileReportName }} ({{ task.ProfileID }})</a>
              </div>
              <div class="f-wb t-al">{{ 'dashboard.tasks.assigned-by' | translate | titlecase }}</div>
              <div class="t-al">{{ task.AssignedByUserName }}</div>
            </div>
            <div class="atlas-tasks-dashboard-actions" style="padding: 0; text-align: center">
              <action-button [label]="'common.actions' | translate | uppercase" [items]="actionItemsForTask(task)"> </action-button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-progressSpinner *ngIf="loading"></p-progressSpinner>
    <div style="margin-top: -3.3em; float: left" *ngIf="(searchResult?.TotalCount ?? 0) > 0">
      <p-select [options]="pageSizeOptions" [(ngModel)]="selectedPageSize" (ngModelChange)="handlePageSizeChange($event)" appendTo="body">
      </p-select>
    </div>
  </div>
</wl-card>

<wl-task-edit-dialog (taskSaved)="loadTasks(true)" #taskEditDialog></wl-task-edit-dialog>

<p-confirmDialog #deleteTaskCD key="deleteTaskCD">
  <ng-template pTemplate="footer">
    <button pButton type="button" (click)="deleteTaskCD.reject()" class="atlas-btn atlas-btn-secondary mr-10">{{ rejectText }}</button>
    <button pButton type="button" (click)="deleteTaskCD.accept()" class="atlas-btn atlas-btn-primary">{{ acceptText }}</button>
  </ng-template>
</p-confirmDialog>
